const links = {
  CONTINENTES: "continentes/",
  PAISES: "paises/",
  ESTADOS: "estados/",
  CIUDADES: "ciudades/",
  CLUBES: "clubes/",
  TIPO_CONTACTO: "tipos_contacto/",
  TIPO_IDENTIFICADOR: "tipos_identificador/",
  PERSONAS: "personas/",
  JUGADORES: "jugadores/",
  TORNEOS: "torneos/",
  CONTACTOS: "contactos/",
  TORNEOS_BY_YEAR: "torneos/by_year/",
  TORNEO_DETALLES: "torneo_detalles/",
  ESTADIOS: "estadios/",
  LOGIN: "login/",
  VISITAS: "web_visit/reporte",
}

module.exports = {
  links
}